import React from 'react';
import RowActions from './RowActions';
import CompressedSize from './CompressedSize';

export default function GetColumns(onCompareButtonClick) {
	const isMobile = window.innerWidth < 576;
	if (isMobile) {
		return [
			{
				title: 'File Uploaded',
				dataIndex: 'name',
				className: 'filename',
				render: (text, file) => {
					return (
						<div>{text} <CompressedSize file={file} classname="m-compressed-size" /></div>
					);
				}
			},
			{
				title: '',
				align: 'right',
				className: 'row-actions',
				render: (text, file) => {
					return (
						<RowActions text={text} file={file} onCompareButtonClick={onCompareButtonClick} />
					);
				}
			}
		];
	}
	return [
		// {
		// 	dataIndex: 'nothing',
		// 	render: (text, record) => {
		// 		const isFilePng = (/\.(png)$/i).test(record.name);
		// 		const src = isFilePng ? Png : Jpg;
		// 		return (
		// 			<img className="table-row-icon" src={src} alt="png" />
		// 		);
		// 	}
		// },
		{
			title: 'File Uploaded',
			className: 'filename',
			dataIndex: 'name',
		}, {
			title: 'Size',
			className: 'size-column',
			render: (text, file) => {
				return (
					<span>{file.sizeFormatted}</span>
				);
			}
		}, {
			title: 'Optimized',
			dataIndex: 'compressedSize',
			className: 'compressed-column',
			render: (text, file) => {
				return (
					<CompressedSize file={file} />
				);
			}
		}, {
			title: '',
			className: 'row-actions',
			render: (text, file) => {
				return (
					<RowActions text={text} file={file} onCompareButtonClick={onCompareButtonClick} />
				);
			}
		}
	];
}



// WEBPACK FOOTER //
// ./src/components/file-table/FileTableColumns.js